import React, { useState, useEffect } from 'react';
import apiService from '../services/ApiService';

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('info');
    const [isProcessing, setIsProcessing] = useState(false);
    const [searchUser, setSearchUser] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        fetchNotificationHistory();
    }, []);

    const fetchNotificationHistory = async () => {
        setLoading(true);
        try {
            const result = await apiService.get('/admin/notifications/all');
            setNotifications(result.data || []);
        } catch (err) {
            console.error('Failed to fetch notifications:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleBroadcast = async (e) => {
        e.preventDefault();
        if (!message.trim()) return;

        setIsProcessing(true);
        try {
            await apiService.post('/admin/notifications/broadcast', {
                message: message.trim(),
                type
            });
            alert('Broadcast sent successfully!');
            setMessage('');
            fetchNotificationHistory();
        } catch (err) {
            alert(err.message || 'Failed to send broadcast');
        } finally {
            setIsProcessing(false);
        }
    };

    const handleSendToUser = async (e) => {
        e.preventDefault();
        if (!selectedUser || !message.trim()) return;

        setIsProcessing(true);
        try {
            await apiService.post('/admin/notifications/send', {
                user_id: selectedUser.user_id,
                message: message.trim(),
                type
            });
            alert(`Notification sent to ${selectedUser.name}!`);
            setMessage('');
            setSelectedUser(null);
            setSearchUser('');
            fetchNotificationHistory();
        } catch (err) {
            alert(err.message || 'Failed to send notification');
        } finally {
            setIsProcessing(false);
        }
    };

    const fetchUsers = async (query) => {
        if (query.length < 3) return;
        try {
            const result = await apiService.get('/users');
            const filtered = (result.users || []).filter(u =>
                u.name?.toLowerCase().includes(query.toLowerCase()) ||
                u.phone_number?.includes(query)
            ).slice(0, 5);
            setUsers(filtered);
        } catch (err) {
            console.error(err);
        }
    };

    if (loading && notifications.length === 0) return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '100px' }}>
            <i className="fas fa-circle-notch fa-spin" style={{ fontSize: '30px', color: 'var(--primary)' }}></i>
        </div>
    );

    return (
        <div className="notifications-page">
            <div className="page-header" style={{ marginBottom: '32px' }}>
                <h2 style={{ fontFamily: 'Outfit', fontSize: '24px', fontWeight: '800', margin: '0', color: 'var(--text-main)' }}>Communications Control</h2>
                <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginTop: '4px' }}>Dispatch system-wide broadcasts or targeted alerts to specific users.</p>
            </div>

            <div className="grid-responsive" style={{ alignItems: 'start' }}>
                {/* Composer Column */}
                <div className="col-7 col-lg-12">
                    <div className="admin-card" style={{ padding: '0', overflow: 'hidden' }}>
                        <div style={{ padding: '24px 32px', borderBottom: '1px solid var(--border-light)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--bg-main)' }}>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: 'var(--text-main)', textTransform: 'uppercase', letterSpacing: '1px' }}>Message Composer</h3>
                            <i className="fas fa-paper-plane" style={{ color: 'var(--primary)', opacity: 0.5 }}></i>
                        </div>

                        <div style={{ padding: '32px' }} className="container-fluid">
                            <div style={{ display: 'flex', gap: '12px', marginBottom: '32px', background: 'var(--bg-main)', padding: '6px', borderRadius: '14px', border: '1px solid var(--border-light)', overflowX: 'auto' }}>
                                <button
                                    onClick={() => setSelectedUser(null)}
                                    style={{
                                        flex: 1, minWidth: '140px', padding: '10px', borderRadius: '10px', border: 'none', cursor: 'pointer',
                                        fontSize: '12px', fontWeight: '800', textTransform: 'uppercase',
                                        background: !selectedUser ? 'white' : 'transparent',
                                        color: !selectedUser ? 'var(--primary)' : 'var(--text-dim)',
                                        boxShadow: !selectedUser ? 'var(--shadow-sm)' : 'none',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Global Broadcast
                                </button>
                                <button
                                    onClick={() => setSelectedUser({ name: '' })}
                                    style={{
                                        flex: 1, minWidth: '140px', padding: '10px', borderRadius: '10px', border: 'none', cursor: 'pointer',
                                        fontSize: '12px', fontWeight: '800', textTransform: 'uppercase',
                                        background: selectedUser ? 'white' : 'transparent',
                                        color: selectedUser ? 'var(--primary)' : 'var(--text-dim)',
                                        boxShadow: selectedUser ? 'var(--shadow-sm)' : 'none',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Targeted Alert
                                </button>
                            </div>

                            <form onSubmit={selectedUser?.user_id ? handleSendToUser : handleBroadcast}>
                                {selectedUser && (
                                    <div className="form-group" style={{ marginBottom: '24px' }}>
                                        <label style={labelStyle}>FIND RECIPIENT</label>
                                        <div style={{ position: 'relative' }}>
                                            <i className="fas fa-user-search" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-dim)' }}></i>
                                            <input
                                                type="text"
                                                placeholder="Type name or phone number..."
                                                value={searchUser}
                                                onChange={(e) => {
                                                    setSearchUser(e.target.value);
                                                    fetchUsers(e.target.value);
                                                }}
                                                style={{ ...inputStyle, paddingLeft: '48px' }}
                                            />
                                            {users.length > 0 && !selectedUser.user_id && (
                                                <div className="search-dropdown">
                                                    {users.map(u => (
                                                        <div key={u.user_id} className="search-item" onClick={() => {
                                                            setSelectedUser(u);
                                                            setUsers([]);
                                                            setSearchUser(u.name || u.phone_number);
                                                        }}>
                                                            <div style={{ fontWeight: '700', fontSize: '13px' }}>{u.name}</div>
                                                            <div style={{ fontSize: '11px', color: 'var(--text-dim)' }}>{u.phone_number}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        {selectedUser.user_id && (
                                            <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', background: 'var(--primary-light)', borderRadius: '10px', border: '1px solid var(--primary)' }}>
                                                <i className="fas fa-check-circle" style={{ color: 'var(--primary)' }}></i>
                                                <span className="text-truncate" style={{ fontSize: '12px', fontWeight: '800', color: 'var(--primary)' }}>RECIPIENT: {selectedUser.name}</span>
                                                <button type="button" onClick={() => { setSelectedUser({ name: '' }); setSearchUser(''); }} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--primary)' }}>×</button>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="form-group" style={{ marginBottom: '24px' }}>
                                    <label style={labelStyle}>MESSAGE CONTENT</label>
                                    <textarea
                                        rows="5"
                                        value={message}
                                        onChange={e => setMessage(e.target.value)}
                                        placeholder="Draft your message here..."
                                        style={{ ...inputStyle, resize: 'none' }}
                                    />
                                </div>

                                <div className="form-group" style={{ marginBottom: '32px' }}>
                                    <label style={labelStyle}>URGENCY CATEGORY</label>
                                    <div className="grid-responsive" style={{ gap: '12px' }}>
                                        {['info', 'success', 'warning', 'error'].map(t => (
                                            <div
                                                key={t}
                                                onClick={() => setType(t)}
                                                className="col-3 col-md-6"
                                                style={{
                                                    padding: '12px 8px', borderRadius: '12px', border: '2px solid',
                                                    borderColor: type === t ? 'var(--primary)' : 'var(--border-light)',
                                                    background: type === t ? 'var(--primary-light)' : 'white',
                                                    cursor: 'pointer', textAlign: 'center', transition: 'all 0.2s'
                                                }}
                                            >
                                                <div style={{
                                                    fontSize: '14px', marginBottom: '4px',
                                                    color: t === 'error' ? 'var(--error)' : t === 'warning' ? 'var(--warning)' : t === 'success' ? 'var(--success)' : 'var(--primary)'
                                                }}>
                                                    <i className={`fas fa-${t === 'error' ? 'exclamation-circle' : t === 'warning' ? 'exclamation-triangle' : t === 'success' ? 'check-circle' : 'info-circle'}`}></i>
                                                </div>
                                                <div style={{ fontSize: '10px', fontWeight: '800', textTransform: 'uppercase', color: 'var(--text-main)' }}>{t}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '16px' }} disabled={isProcessing}>
                                    {isProcessing ? <i className="fas fa-spinner fa-spin"></i> : (
                                        <>
                                            <i className="fas fa-paper-plane" style={{ marginRight: '8px' }}></i>
                                            {selectedUser?.user_id ? 'Dispatch Targeted Alert' : 'Fire Global Broadcast'}
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* History Column */}
                <div className="col-5 col-lg-12">
                    <h3 style={{ ...sectionHeaderStyle, marginBottom: '20px' }}>Recent Transmissions</h3>
                    <div className="notification-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {notifications.length > 0 ? notifications.map((n, i) => (
                            <div key={i} className="admin-card" style={{ padding: '20px', border: '1px solid var(--border-light)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                                    <span className={`status-badge ${n.type === 'error' ? 'status-rejected' : n.type === 'success' ? 'status-completed' : 'status-in_progress'}`} style={{ fontSize: '10px', padding: '4px 10px' }}>
                                        {n.type}
                                    </span>
                                    <span style={{ fontSize: '11px', color: 'var(--text-dim)', fontWeight: '600' }}>
                                        {new Date(n.createdAt).toLocaleDateString('en-GB')}
                                    </span>
                                </div>
                                <p style={{ margin: '0 0 12px 0', fontSize: '14px', lineHeight: '1.6', color: 'var(--text-main)', fontWeight: '500' }}>{n.message}</p>
                                <div style={{ padding: '8px 12px', background: 'var(--bg-main)', borderRadius: '8px', fontSize: '11px', color: 'var(--text-dim)', fontWeight: '700', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                    <i className="fas fa-bullseye" style={{ fontSize: '10px' }}></i>
                                    <span className="text-truncate">TO: {n.user_id?.name || 'PUBLIC BROADCAST'}</span>
                                </div>
                            </div>
                        )) : (
                            <div style={{ textAlign: 'center', padding: '40px', background: 'white', borderRadius: '24px', opacity: 0.6 }}>
                                <i className="fas fa-ghost" style={{ fontSize: '30px', marginBottom: '12px', display: 'block' }}></i>
                                <span style={{ fontWeight: '700', fontSize: '13px' }}>History Silenced</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>


            <style>{`
        .search-dropdown { position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid var(--border-light); border-radius: 12px; z-index: 100; box-shadow: var(--shadow-lg); margin-top: 8px; overflow: hidden; }
        .search-item { padding: 12px 16px; cursor: pointer; transition: background 0.2s; }
        .search-item:hover { background: var(--bg-main); }
        .notification-list { max-height: 800px; overflow-y: auto; padding-right: 4px; }
        .notification-list::-webkit-scrollbar { width: 4px; }
        .notification-list::-webkit-scrollbar-thumb { background: var(--border-light); borderRadius: 10px; }
      `}</style>
        </div>
    );
};

const sectionHeaderStyle = {
    fontSize: '11px',
    fontWeight: '800',
    color: 'var(--text-muted)',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
};

const labelStyle = {
    display: 'block',
    fontSize: '10px',
    fontWeight: '800',
    color: 'var(--text-dim)',
    letterSpacing: '1px',
    marginBottom: '8px'
};

const inputStyle = {
    width: '100%',
    padding: '14px 16px',
    borderRadius: '12px',
    border: '1px solid var(--border-light)',
    fontSize: '14px',
    fontFamily: 'inherit',
    fontWeight: '600',
    background: '#fcfcfc',
    transition: 'all 0.2s',
    outline: 'none',
    boxSizing: 'border-box'
};

export default Notifications;
